import CURRENCIES from './currencies.js';

var normalize = function normalize(_ref) {
  var _ref$currencyCode = _ref.currencyCode,
    currencyCode = _ref$currencyCode === void 0 ? 'USD' : _ref$currencyCode,
    amount = _ref.amount;
  amount = parseFloat(amount) || 0;
  try {
    var _currencyCode;
    currencyCode = ((_currencyCode = currencyCode) !== null && _currencyCode !== void 0 ? _currencyCode : 'USD').toLocaleUpperCase();
  } catch (error) {
    console.error('Error with converting currency code', error);
    currencyCode = 'USD';
  }
  if (!CURRENCIES[currencyCode]) {
    currencyCode = 'USD';
  }
  var decimal_digits = CURRENCIES[currencyCode].decimal_digits;
  var precision = Math.pow(10, decimal_digits);

  // Round before parsing to correct any floating-point inaccuracies
  return parseInt(Math.round(amount * precision), 10);
};

export { normalize as default };
//# sourceMappingURL=normalize.js.map
